import { render, staticRenderFns } from "./TableInlinePagination.vue?vue&type=template&id=cafb6cbc&scoped=true&lang=pug&"
import script from "./TableInlinePagination.vue?vue&type=script&lang=ts&"
export * from "./TableInlinePagination.vue?vue&type=script&lang=ts&"
import style0 from "./TableInlinePagination.vue?vue&type=style&index=0&id=cafb6cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb6cbc",
  null
  
)

export default component.exports